export const ROLES = {
  SELLER: 'seller',
  BUYER: 'buyer',
}

export const PERMISSIONS = {
  USER_DASHBOARD: 'user_dashboard',
  CREATE_USER: 'create_user',
  EDIT_USER: 'edit_user',
	FACILITY_DASHBOARD: 'facility_dashboard',
	CREATE_FACILITY: 'create_facility',
	EDIT_FACILITY: 'edit_facility',
	DELETE_FACILITY: 'delete_facility',
	DELETE_USER: 'delete_user',
  REPORTS_DASHBOARD: 'reports_dashboard',
  SETTINGS_DASHBOARD: 'settings_dashboard',
  BASIC_SETTINGS: 'basic_settings'
}

export const rolePermissions = {
  [ROLES.SELLER]: [
    PERMISSIONS.USER_DASHBOARD,
    PERMISSIONS.CREATE_USER,
    PERMISSIONS.EDIT_USER,
    PERMISSIONS.DELETE_USER,
		PERMISSIONS.FACILITY_DASHBOARD,
		PERMISSIONS.CREATE_FACILITY,
		PERMISSIONS.EDIT_FACILITY,
		PERMISSIONS.DELETE_FACILITY,
    PERMISSIONS.REPORTS_DASHBOARD,
    PERMISSIONS.SETTINGS_DASHBOARD,
    PERMISSIONS.BASIC_SETTINGS
  ],

  [ROLES.BUYER]: [
  ]
}